import { render, staticRenderFns } from "./shijuangailan.vue?vue&type=template&id=355b0383&"
import script from "./shijuangailan.vue?vue&type=script&lang=ts&"
export * from "./shijuangailan.vue?vue&type=script&lang=ts&"
import style0 from "./shijuangailan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports